var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col md:flex-row h-fit w-full md:w-8/12 px-4 md:px-0 mx-auto"},[_c('div',{staticClass:"w-full md:w-6/12 h-full md:sticky top-10 mb-10 md:mb-0"},[_c('img',{staticClass:"h-full w-auto",attrs:{"src":("" + (require('@/assets/img/resumo-executivo/logo.png'))),"alt":""}})]),_c('div',{staticClass:"w-full 1080p:w-8/12 md:w-6/12 p-0 md:pl-8 h-fit"},[_c('h1',{staticClass:"font-serif font-semibold text-5xl text-black mb-2 leading-none -mt-2"},[_vm._v("Resumo executivo")]),_vm._m(0),_c('ul',{staticClass:"flex flex-col justify-between gap-2 mb-10"},[_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":"/resumo-executivo/prefacio"}},[_c('small',[_vm._v("Apresentação")]),_c('h2',[_vm._v("FAPESP 60 anos, por Carlos Vogt")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":"/apresentacao"}},[_c('small',[_vm._v("PREFÁCIO")]),_c('h2',{staticClass:"w-full 1080p:w-1/2"},[_vm._v("FAPESP, um patrimônio da população paulista, por Marco Antonio Zago")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'SingleExecSumView',
                        params: {
                            slug: 'seis-decadas-de-realizacoes',
                            idx: '1',
                            componentName: 'Texto1PT',
                            fa: 1,
                        },
                    }}},[_c('small',[_vm._v("Fascículo 1")]),_c('h2',[_vm._v("Seis décadas de realizações")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'SingleExecSumView',
                        params: {
                            slug: 'dna-da-ciencia-paulista',
                            idx: '2',
                            componentName: 'Texto2PT',
                            fa: 1,
                        },
                    }}},[_c('small',[_vm._v("Fascículo 2")]),_c('h2',[_vm._v("DNA da ciência paulista")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'SingleExecSumView',
                        params: {
                            slug: 'pioneirismo-digital',
                            componentName: 'Texto3PT',
                            idx: '3',
                            fa: 1,
                        },
                    }}},[_c('small',[_vm._v("Fascículo 3")]),_c('h2',[_vm._v("Pioneirismo digital")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'SingleExecSumView',
                        params: {
                            slug: 'grandes-projetos-grandes-resultados',
                            componentName: 'Texto4PT',
                            idx: '4',
                            fa: 1,
                        },
                    }}},[_c('small',[_vm._v("Fascículo 4")]),_c('h2',[_vm._v("Grandes projetos, grandes resultados")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'SingleExecSumView',
                        params: {
                            slug: 'politicas-publicas-baseadas-em-evidencias',
                            componentName: 'Texto5PT',
                            idx: '5',
                            fa: 1,
                        },
                    }}},[_c('small',[_vm._v("Fascículo 5")]),_c('h2',[_vm._v("Políticas públicas baseadas em evidências")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'SingleExecSumView',
                        params: {
                            slug: 'contribuicao-social-cultural-e-artistica',
                            componentName: 'Texto6PT',
                            idx: '6',
                            fa: 1,
                        },
                    }}},[_c('small',[_vm._v("Fascículo 6")]),_c('h2',[_vm._v("Contribuição social, cultural e artística")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'SingleExecSumView',
                        params: {
                            slug: 'inovacao-e-empreendedorismo',
                            componentName: 'Texto6PT',
                            idx: '7',
                            fa: 1,
                        },
                    }}},[_c('small',[_vm._v("Fascículo 7")]),_c('h2',[_vm._v("Inovação e empreendedorismo")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'SingleExecSumView',
                        params: {
                            slug: 'diversidade-e-inclusao',
                            componentName: 'Texto7PT',
                            idx: '8',
                            fa: 1,
                        },
                    }}},[_c('small',[_vm._v("Fascículo 8")]),_c('h2',[_vm._v("Diversidade e inclusão")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'SingleExecSumView',
                        params: {
                            slug: 'licoes-da-pandemia',
                            componentName: 'Texto6PT',
                            idx: '9',
                            fa: 1,
                        },
                    }}},[_c('small',[_vm._v("Fascículo 9")]),_c('h2',[_vm._v("Lições da pandemia")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'SingleExecSumView',
                        params: {
                            slug: 'de-olho-no-futuro',
                            componentName: 'Texto6PT',
                            idx: '10',
                            fa: 1,
                        },
                    }}},[_c('small',[_vm._v("Fascículo 10")]),_c('h2',[_vm._v("De olho no futuro")])])],1),_c('li',[_c('router-link',{staticClass:"execSum_index",attrs:{"to":{
                        name: 'ExecSumView',
                        // params: {
                        //     slug: 'indicadores',
                        //     componentName: 'IndicatorsAll',
                        // },
                    }}},[_c('small',[_vm._v("Resumo executivo")]),_c('h2',[_vm._v("Indicadores FAPESP 60 anos")])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-6"},[_c('button',{staticClass:"font-semibold"},[_vm._v("See English version")])])}]

export { render, staticRenderFns }